// removed by extract-text-webpack-plugin
module.exports = {"key__themes":"src-components-KeyThemes----KeyThemes-module---key__themes---3gCLV","key__themes__conclusion":"src-components-KeyThemes----KeyThemes-module---key__themes__conclusion---1gE1x","key__themes__title":"src-components-KeyThemes----KeyThemes-module---key__themes__title---3Hmsn","key__themes__list":"src-components-KeyThemes----KeyThemes-module---key__themes__list---7jn0n","key__themes__conclusion__content":"src-components-KeyThemes----KeyThemes-module---key__themes__conclusion__content---1mjD0"};


//////////////////
// WEBPACK FOOTER
// ./src/components/KeyThemes/KeyThemes.module.scss
// module id = 849
// module chunks = 35783957827783